/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1456
 */

var r = require(/* 1444 */"./1444")
var i = require(/* 1176 */"../../../../../2466/1436/1176/index")
var o = require(/* 1179 */"../../2545/1179/index")
var a = require(/* 1445 */"./1445")
var s = Object.getOwnPropertySymbols ? function (e) {
  for (var t = []; e;) {
    r(t, o(e))
    e = i(e)
  }
  return t
} : a
module.exports = s
